import React from "react"
import { NavContainer, Social, Email, Footer } from "@components"
import "../styles/main.css"
import styled, { ThemeProvider } from "styled-components"
import theme from "../styles/theme"

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

export default function Layout({ children }) {
  return (
    <div id="root">
      <ThemeProvider theme={theme}>
        <StyledContent>
          <NavContainer />
          <Social />
          <Email />
          <main>{children}</main>
          <Footer />
        </StyledContent>
      </ThemeProvider>
    </div>
  )
}
